import { render, staticRenderFns } from "./LangBtn.vue?vue&type=template&id=0dd41a4d"
import script from "./LangBtn.vue?vue&type=script&lang=js"
export * from "./LangBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports